import { z } from 'zod';

// Base SSE event schema — validates the payload is a JSON object.
// Individual event names determine the required fields for each callback.
export const SSEEventDataSchema = z.object({}).passthrough();
